(ns ui.captions.styles
  "The caption styles: one HyperFrames composition each below
   hyperframes-templates/captions/<id>/, ported from the HyperFrames
   catalog's caption components.")

(def styles
  [{:id "highlight" :name "Highlight" :description "Red sweep behind the spoken word, TikTok style"}
   {:id "pill-karaoke" :name "Pill karaoke" :description "Dark pill, the spoken word lights up"}
   {:id "editorial-emphasis" :name "Editorial" :description "Quiet sans with one big italic serif word"}
   {:id "clip-wipe" :name "Clip wipe" :description "Bold uppercase words wiped in left to right"}
   {:id "gradient-fill" :name "Gradient fill" :description "Gradient runs through each word as it is spoken"}
   {:id "neon-glow" :name "Neon glow" :description "Cyan neon glow on the spoken word, magenta for emphasis"}
   {:id "neon-accent" :name "Neon accent" :description "Multi-color neon accents with a slow drift"}
   {:id "weight-shift" :name "Weight shift" :description "Two lowercase lines, the weight moves with the speech"}
   {:id "glitch-rgb" :name "Glitch RGB" :description "RGB split glitch on each word, scanlines"}
   {:id "kinetic-slam" :name "Kinetic slam" :description "One huge word at a time, slammed in"}
   {:id "matrix-decode" :name "Matrix decode" :description "Green characters scramble into each word"}
   {:id "emoji-pop" :name "Emoji pop" :description "Stroked uppercase with an emoji per phrase"}
   {:id "particle-burst" :name "Particle burst" :description "Emphasized words explode into particles"}
   {:id "parallax-layers" :name "Parallax layers" :description "Big red serif word behind, phrase in front"}
   {:id "camera-follow" :name "Camera follow" :description "The words stay, the camera pulls back over them"}
   {:id "texture" :name "Texture" :description "Huge single words filled with a flowing texture"}])

(def default-style
  "highlight")

(defn find-style
  [id]
  (some (fn [style]
          (when (= (:id style) id)
            style))
        styles))
